const API_ROUTES = Object.freeze({
  MACHINES: "/api/machines/",
  KPI_STATS: "/api/device-kpi-stats/",
  EVENTS: "/api/events/",
  TRUCK_EVENTS: "/api/truck-events/",
  TRUCK_EVENTS_OVERVIEW: "/api/device-truck-events-overview/",
  TRUCK_EVENTS_BATCH_EDIT: "/api/truck-events-base/batch-edit/",
  VIDEO: "/api/videos/around/",
  GPS: "/api/gps/",
  EVENT_DETAIL: "/api/events/",
  CYCLE_DETAIL: "/api/cycles/",
});

const QUERY_KEYS = Object.freeze({
  MACHINES: "machines",
  KPI_STATS: "kpi-stats",
  EVENTS: "events",
  TRUCK_EVENTS: "truck-events",
  TRUCK_EVENTS_OVERVIEW: "truck-events-overview",
  TRUCK_EVENTS_BATCH_EDIT: "truck-events-batch-edit",
  VIDEO: "videos",
  GPS: "gps",
  EVENT_DETAIL: "event-detail",
  CYCLE_DETAIL: "cycle-detail",
})

export { API_ROUTES, QUERY_KEYS };
